import { DropdownOption, Nullable } from 'src/types/@custom_types/helpers.types';
import {
  CLEAR_MANIFEST,
  CLEAR_MANIFEST_SERVICE_APPLETS,
  SET_MANIFEST_FILTERS,
  SET_MANIFEST_NON_SESSION,
  SET_MANIFEST_SERVICE_APPLETS,
  SET_MANIFEST_SESSION,
  SET_MANIFEST_SESSION_OVERVIEW,
} from '../actions/manifest';
import moment, { Moment } from 'moment';

export type TManifestSessionOverview = {
  fullscreenImage: boolean;
};

export type TManifestServiceApplets = {
  data: TManifestServiceAppletsData[];
  isLoading: boolean;
  error: Nullable<string>;
};

export type TManifestServiceAppletsData = {
  code: Nullable<string>;
  name: Nullable<string>;
  app_logo: Nullable<string>;
};

export type TManifestSession = {
  sites: Array<DropdownOption>;
  tags: Array<DropdownOption>;
};

export type TManifestNonSession = {
  sites: Array<DropdownOption>;
  tags: Array<DropdownOption>;
};

export type TManifestFilters = {
  results: number;
  dateFilter: boolean;
  startTime: Moment;
  endTime: Moment;
  pageCount: number;
  eventsPerPage: number;
  offset: number;
  currentPage: number;
  sortValue: string;
  search: string;
  sort_by: string;
  apps: string[];
  sessionTableFilters: {
    session_ids: string[];
    vehicle_ids: string[];
    order_numbers: string[];
    upcs: string[];
    product_numbers: string[];
    classifications: string[];
    status: string[];
    critical_events: string[];
    sites: number[];
    sort: 'DESC' | 'ASC';
    tags: number[];
  };
  eventTableFilters: {
    sites: number[];
    feeders: number[];
    locations: number[];
    locations_sites: string[];
    locations_floors: string[];
    status: string[];
    event_types: string[];
    events: string[];
    tags: number[];
  };
};

export type TManifest = {
  session: TManifestSession;
  nonSession: TManifestNonSession;
  sessionOverview: TManifestSessionOverview;
  serviceApplets: TManifestServiceApplets;
  filters: TManifestFilters;
};

export const initialState: TManifest = {
  session: {
    sites: [],
    tags: [],
  },
  nonSession: {
    sites: [],
    tags: [],
  },
  sessionOverview: {
    fullscreenImage: false,
  },
  serviceApplets: {
    data: [],
    isLoading: false,
    error: null,
  },
  filters: {
    results: 0,
    dateFilter: false,
    startTime: moment().subtract(7, 'days').startOf('day'),
    endTime: moment().subtract(1, 'days').endOf('day'),
    pageCount: 1, // default to zero
    eventsPerPage: 100,
    offset: 0,
    currentPage: 0,
    sortValue: 'Most Recent',
    search: '',
    sort_by: 'site_timestamp_utc',
    apps: [],
    sessionTableFilters: {
      session_ids: [],
      vehicle_ids: [],
      order_numbers: [],
      upcs: [],
      product_numbers: [],
      classifications: [],
      status: [],
      critical_events: [],
      sites: [],
      sort: 'DESC',
      tags: [],
    },
    eventTableFilters: {
      sites: [],
      locations: [],
      locations_sites: [],
      locations_floors: [],
      feeders: [],
      status: [],
      event_types: [],
      events: [],
      tags: [],
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MANIFEST_SESSION: {
      return { ...state, session: { ...state.session, ...action.data } as TManifestSession };
    }
    case SET_MANIFEST_NON_SESSION: {
      return { ...state, nonSession: { ...state.nonSession, ...action.data } as TManifestNonSession };
    }
    case SET_MANIFEST_SESSION_OVERVIEW: {
      return { ...state, sessionOverview: { ...state.sessionOverview, ...action.data } as TManifestSessionOverview };
    }
    case SET_MANIFEST_SERVICE_APPLETS: {
      return { ...state, serviceApplets: { ...state.serviceApplets, ...action.data } as TManifestServiceApplets };
    }
    case SET_MANIFEST_FILTERS: {
      return { ...state, filters: { ...state.filters, ...action.data } as TManifestFilters };
    }
    case CLEAR_MANIFEST_SERVICE_APPLETS: {
      return {
        ...state,
        serviceApplets: {
          data: [],
          isLoading: false,
          error: null,
        },
      };
    }
    case CLEAR_MANIFEST: {
      return initialState;
    }
    case CLEAR_MANIFEST_SERVICE_APPLETS: {
      return { ...state, serviceApplets: initialState.serviceApplets };
    }
    default:
      return state;
  }
};
